'use client';
import { Header } from '@/ui-components/organisms/Header/Header';
import { Grid } from '@/ui-components/atoms/Layout/Grid/Grid';
import { Text } from '@/ui-components/atoms/Text/Text';
import { StyledContainer } from '@/ui-components/atoms/Layout/StyledContainer/StyledContainer';
import { RenderRTE } from '@/components-2.0/structure/RenderRTE';
import { FlexibleFormVariant } from './FlexibleFormBase';
import { FlexibleFormVariantFactoryArgs, leftAlignedHeaderStyles } from './flexibleFormVariantHelpers';
import styles from './flexibleForm.module.scss';

const {
    descriptionTextStyles,
    flexForm,
    halfWidth,
    fullWidth,
    formSectionHeaderStyles,
    formSectionTextBlockStyles,
    dropdownSelectStyles,
    submitButtonWrapperRight,
    wrapperRow,
    stateContainer,
    stateWrapper,
    zipInputStyles,
    selectorStyles,
    duplicationFormError,
    ctaCaption,
    flepzShell,
    flepzAlert,
} = styles;

export function createFlepzVariant({
    asset,
    toggleForm,
    hasHeadlineContent,
}: FlexibleFormVariantFactoryArgs): Pick<FlexibleFormVariant, 'styles' | 'submitButtonFitting' | 'renderContent'> {
    return {
        styles: {
            flexForm,
            halfWidth,
            fullWidth,
            formSectionHeaderStyles,
            formSectionTextBlockStyles,
            dropdownSelectStyles,
            wrapperRow,
            stateContainer,
            stateWrapper,
            zipInputStyles,
            selectorStyles,
        },
        submitButtonFitting: 'fill-container',
        renderContent: (contentArgs) => {
            const flepzAlertMessage =
                contentArgs.submitState !== 'duplicate' && contentArgs.validations.form?.validations.formerror
                    ? contentArgs.validations.form.helperText.formerror
                    : null;

            return (
                <Grid container>
                    {hasHeadlineContent && !toggleForm && (
                        <Grid col={{ sm: 12, md: 6 }} standardMoleculeSpacing>
                            <Header
                                headingTag="h2"
                                heading={<RenderRTE contentfulDoc={asset.fields.headline} />}
                                theme="left"
                                className={leftAlignedHeaderStyles}
                            />
                        </Grid>
                    )}
                    <Grid col={{ sm: 12, md: 12 }}>
                        <div className={flepzShell}>
                            <Text tag="p" className={descriptionTextStyles}>
                                <RenderRTE contentfulDoc={asset.fields.description} />
                            </Text>
                            {flepzAlertMessage && <div className={flepzAlert}>{flepzAlertMessage}</div>}
                            <div className={flexForm}>
                                {contentArgs.wrappedFieldElements}
                                <div className={submitButtonWrapperRight}>
                                    {contentArgs.duplicateError && (
                                        <StyledContainer>
                                            <Text tag="div" className={duplicationFormError} role="alert">
                                                {contentArgs.duplicateErrorMessage}
                                            </Text>
                                        </StyledContainer>
                                    )}
                                    {contentArgs.submitButton}
                                    {asset.fields.cta_caption && (
                                        <RenderRTE contentfulDoc={asset.fields.cta_caption} className={ctaCaption} />
                                    )}
                                </div>
                            </div>
                        </div>
                    </Grid>
                </Grid>
            );
        },
    };
}
